//菜单汇率别管理
import React from 'react'
import Manager from '../../public/components/Manager'
import ExchangeRateDiv from './ExchangeRateDiv'
import ExchangeRateListDiv from './ExchangeRateListDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [
        {
            icon: 'plus', text: '添加...', handler: ({ showDetail, refreshPage }) =>
                Tyan.pubForm.showDialog('汇率', props => <ExchangeRateListDiv {...props} onSave={refreshPage} />)
        },
    ],
    columns: [
        { _date: '月份', field: 'ValidStartDate', minWidth: 150, flex: 1, format: 'yyyy/MM' },
        { _text: '本币', minWidth: 150, flex: 1 },
        { _text: '外币', minWidth: 150, flex: 1 },
        { _text: '外币汇率', field: 'ExchangeRate', minWidth: 150, flex: 1 },
        { _datetime: '创建时间', minWidth: 150, flex: 1 },
        { _text: '创建人', minWidth: 150, flex: 1 },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        Tyan.pubForm.showDialog('汇率', props => <ExchangeRateDiv {...props} id={data.id} onSave={refreshPage} />)
    }
}

export default props => <Manager {...props} config={config} />